import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4900To4999Service {

  constructor() { }
}
